export const hotkeyFive = "eqeRMd";
export const hotkeySix = "KIj6Cd";
export const hotkeySeven = "Tv16Le";
export const hotkeyEight = "HkQ8Ge";
export const hotkeyNine = "WUL9ab";
export default {hotkeyFive,hotkeySix,hotkeySeven,hotkeyEight,hotkeyNine};